import { HedgeForm } from '@/components/hedge-form'
import { Button } from '@/components/ui/button'
import { Link, createFileRoute } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_layout/hedges/new')({
  component: NewHedgePage,
})

function NewHedgePage() {
  const { t } = useTranslation()

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" asChild>
          <Link to="/hedges">
            <ArrowLeft className="w-5 h-5" />
          </Link>
        </Button>
        <div>
          <h1 className="text-2xl font-semibold">{t('hedge.title')}</h1>
          <p className="text-sm text-muted-foreground mt-1">{t('hedge.subtitle')}</p>
        </div>
      </div>

      {/* Form */}
      <HedgeForm />
    </div>
  )
}
